import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects'
import { changeActiveTemplateId, deleteTemplate, getActiveTemplateId, getTemplates, updateTemplate, createTemplate } from '../services/pseudoApi/template'
import { fetchChangeActiveTemplateIdSuccess, fetchCreateTemplateSuccess, fetchDeleteTemplateSuccess, fetchTemplatesSuccess, fetchSaveTemplateSuccess } from '../actions/Template'
import { FETCH_CHANGE_ACTIVE_TEMPLATE_ID, FETCH_CREATE_TEMPLATE, FETCH_DELETE_TEMPLATE, FETCH_TEMPLATES, FETCH_SAVE_TEMPLATE } from '../constants/ActionTypes'

const getTemplateFromState = ({templates}, id) => templates.byId[id]

// Fetch Templates

export function* tryGetTemplates () {
  try {
    const fetchedTemplates = yield call(getTemplates)
    const activeTemplateId = yield call(getActiveTemplateId)

    yield put(fetchTemplatesSuccess(fetchedTemplates, Object.getOwnPropertyNames(fetchedTemplates), activeTemplateId))
  } catch (error) {

  }
}

export function* watchFetchTemplates () {
  yield takeEvery(FETCH_TEMPLATES, tryGetTemplates)
}

// Change Active Template ID

export function* tryChangeActiveTemplateId ({payload}) {
  try {
    const {id} = payload

    const templateFromState = yield select(getTemplateFromState, id)
    const activeTemplateId = yield call(changeActiveTemplateId, id)

    yield put(fetchChangeActiveTemplateIdSuccess(activeTemplateId, `Current template has been changed to "${templateFromState.name}"`))
  } catch (error) {

  }
}

export function* watchFetchChangeActiveTemplateId () {
  yield takeEvery(FETCH_CHANGE_ACTIVE_TEMPLATE_ID, tryChangeActiveTemplateId)
}

// Create Template

export function* tryCreateTemplate ({payload}) {
  try {
    const {name} = payload

    const fetchedCreatedTemplate = yield call(createTemplate, name)
    const activeTemplateId = yield call(getActiveTemplateId)

    yield put(fetchCreateTemplateSuccess(fetchedCreatedTemplate.id, fetchedCreatedTemplate, activeTemplateId, `Template "${fetchedCreatedTemplate.name}" has been created`))
  } catch (error) {

  }
}

export function* watchFetchCreateTemplate () {
  yield takeEvery(FETCH_CREATE_TEMPLATE, tryCreateTemplate)
}

// Save Template

export function* trySaveTemplate ({payload}) {
  try {
    const {id} = payload
    const templateFromState = yield select(getTemplateFromState, id)

    yield call(updateTemplate, id, templateFromState)

    yield put(fetchSaveTemplateSuccess(id, `Template "${templateFromState.name}" has been updated`))
  } catch (error) {

  }
}

export function* watchFetchSaveTemplate () {
  yield takeEvery(FETCH_SAVE_TEMPLATE, trySaveTemplate)
}

// Delete Template

export function* tryDeleteTemplate ({payload}) {
  try {
    const {id} = payload

    const templateFromState = yield select(getTemplateFromState, id)
    yield call(deleteTemplate, id)
    const activeId = yield call(getActiveTemplateId)

    yield put(fetchDeleteTemplateSuccess(id, activeId, `Template "${templateFromState.name}" has been deleted`))
  } catch (error) {

  }
}

export function* watchFetchDeleteTemplate () {
  yield takeEvery(FETCH_DELETE_TEMPLATE, tryDeleteTemplate)
}

// Root

export default function* rootSaga () {
  yield all([fork(watchFetchTemplates), fork(watchFetchChangeActiveTemplateId), fork(watchFetchCreateTemplate), fork(watchFetchSaveTemplate), fork(watchFetchDeleteTemplate)])
}


// WEBPACK FOOTER //
// ./sagas/Template.js